export default __webpack_public_path__ + "static/media/runner.9611c72f.png";